export function useLanguageSwitcher(target: string) {
    onMounted(() => {
        const languagesList = document.querySelector(target)?.children

        if (!languagesList) {
            return
        }

        const path = useRoute().path
        const { siteUrl } = useRuntimeConfig().public

        function generateLink(lang: string) {
            return `${siteUrl}/${lang}${path.substring(3)}`
        }

        for (const language of languagesList) {
            if (language instanceof HTMLAnchorElement) {
                if (language.textContent?.includes('pl')) {
                    language.href = generateLink('pl')
                }

                if (language.textContent?.includes('en')) {
                    language.href = generateLink('en')
                }

                if (language.textContent?.includes('ru')) {
                    language.href = generateLink('ru')
                }
            }
        }
    })
}
